import { upperCase, words } from 'voca';
import GraphemeSplitter from 'grapheme-splitter';
import { Currency } from '~client/model/currency';
import { isNilOrEmpty, not } from '~common/helper/global';

export const getInitials = (name: string): string => {
  if (name) {
    const splitter = new GraphemeSplitter();
    const initials = words(name).map((word) => {
      if (isNilOrEmpty(word)) {
        return '';
      }
      return upperCase(splitter.iterateGraphemes(word).next().value);
    });
    if (initials.length > 1) {
      return `${initials[0]}${initials[initials.length - 1]}`;
    } else {
      return initials[0];
    }
  }
  return name;
};

export const getFullName = (firstName: string, lastName: string): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return '';
};

//TODO(DMITRY): Move this func to a view helper if not used in many places
/**
 * Returns email if no first name or last name provided (e.g. pending assignment token state)
 * @param firstName
 * @param lastName
 * @param email
 */
export const getNameOrEmail = (firstName: string, lastName: string, email: string): string => {
  if (firstName || lastName) {
    return getFullName(firstName, lastName);
  }
  if (email) {
    return email;
  }
  return '';
};

/**
 * Removes the accents from a string and replace them by the letters without them
 * @param s
 */
export const normalize: (s: string) => string = (s: string): string => {
  if (!s) {
    return null;
  }
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

/**
 * Remove spaces from a string
 * @param aString
 */
export const removeSpaces = (aString: string): string => {
  if (aString) {
    return aString.replace(/\s/g, '');
  }
  return aString;
};

/**
 * Keep only the numbers in a string
 * @param value
 */
export const keepNumbersOnly = (value = ''): string => value.replace(/\D/g, '');

/**
 * Remove numbers from a string
 * @param value
 */
export const removeNumbers = (value = ''): string => value.replace(/\d+/g, '');

/**
 * Remove letters from a string
 * @param value
 */
export const removeLetters = (value: string): string => value.replace(/[A-Za-z]+/g, '');

/**
 * An empty string - use this instead of '' because it might cause problems
 */
export const emptyString: string = String.fromCharCode(160);

/**
 * Joins the string with the given separator, but after removing all nulls.
 * @param strings
 * @param separator
 */
export const joinNonNull = (strings: string[], separator = ' '): string => {
  return strings.filter(not(isNilOrEmpty)).join(separator);
};

/**
 * Get the symbol of a currency
 * @param currency
 * @param locale
 */
export const getCurrencySymbol = (currency: Currency, locale: string): string =>
  removeNumbers(
    new Intl.NumberFormat(locale, {
      style: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currency: currency ? currency : Currency.USD,
    }).format(0),
  );

/**
 * Strip a string to a maximum length and add the "..." char at its end
 * TODO this function should be used in event description
 * @param input
 * @param length
 */
export const ellipsise = (input: string, length: number): string => {
  if (input.length > length) {
    return input.substring(0, length - 1) + '\u2026';
  } else {
    return input;
  }
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/helper/string.ts